import React from 'react';
import { Link } from 'react-router-dom';

const InternalServerError = () => {
  return (
    <>
      <h1>500 - Internal Server Error</h1>
      <div>
        Une erreur s&apos;est produite, merci de contacter votre administrateur
        immédiatement.
      </div>
      <Link to={'/'}>Retour vers la page d&apos;accueil</Link>
    </>
  );
};

export default InternalServerError;
